module.exports = __webpack_public_path__ + "img/csm.012afc79.svg";